import React, { useMemo } from 'react';
import Button from '../../../muiComponents/Button';
import useTranslate from '../../../customHooks/useTranslate';
import {
    useProperty,
    usePropertyProgress,
    usePropertySaving,
    usePropertyValidation,
} from '../../contextsProperty/ContextProperties';
import {
    PROGRESS_MAIN_INFORMATION_TAB,
    PROGRESS_STEP,
} from '../../../types/properties/propertyTypes';
import { useHistory } from 'react-router-dom';
import {
    tabsData,
    URL_HOTEL_BASE,
    URL_TAB_PARAM,
} from '../../../utils/property/propertyUtils';

const FooterYourProperty = () => {
    const translate = useTranslate();
    const history = useHistory();
    const { id } = useProperty();
    const { activeTabKey, activeTab, handleForwardProgress, activeStep } =
        usePropertyProgress();
    const { handleSave } = usePropertySaving();
    const { handleIsValidated, handleValidate } = usePropertyValidation();

    const isLastStep = useMemo(() => {
        return (
            tabsData[activeStep as PROGRESS_STEP]?.numberOfTabs === activeTab
        );
    }, [activeTab]);

    return (
        <div
            className={`your-properties__footer ${
                activeTab === 1 ? 'flex-end' : 'flex-between'
            }`}
        >
            {activeTab !== 1 ? (
                <Button
                    variant='outlined'
                    onClick={() => {
                        history.push(URL_TAB_PARAM(activeTab - 1));
                    }}
                >
                    {translate('back')}
                </Button>
            ) : (
                ''
            )}

            <Button
                variant='contained'
                onClick={async () => {
                    handleIsValidated(true);
                    const isValidated = handleValidate(
                        activeTabKey as PROGRESS_MAIN_INFORMATION_TAB
                    );
                    if (isValidated && activeStep) {
                        const newProgress = handleForwardProgress(activeStep);
                        if (isLastStep) {
                            await handleSave(newProgress);
                            history.push(URL_HOTEL_BASE(id));
                        } else {
                            history.push(URL_TAB_PARAM(activeTab + 1));
                        }
                    }
                }}
            >
                {translate(isLastStep ? 'finish' : 'next')}
            </Button>
        </div>
    );
};

export default FooterYourProperty;
